/** Format a capacity stored in kW for display: "50 kW" below 1 MW, "5.0 MW" at or above.
 *  The single copy of this rule — ProjectList, the wizard, the checkup and the
 *  project report all render capacity through it. */
export function formatCapacity(kw: number): string {
  return kw >= 1000 ? `${(kw / 1000).toFixed(1)} MW` : `${kw} kW`;
}

/** Safely parse a JSON string, returning fallback on failure.
 *  Handles Supabase returning Postgres text[] as native JS arrays. */
export function tryParseJSON<T>(value: string | T | null | undefined, fallback: T): T {
  if (value == null) return fallback;
  if (typeof value !== "string") return value as T;
  if (value === "") return fallback;
  try { return JSON.parse(value); } catch { return fallback; }
}
